import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack, { ChoiceCard } from './FieldStack';
import { InputField } from '../../../ui/input-field';
import { Snowflake, Wind, Home, Square, Layers, X } from 'lucide-react';

const Cooling = () => {
  const [uses, setUses] = useState('no');
  const [hoursPerDay, setHoursPerDay] = useState(4);
  const [monthsPerYear, setMonthsPerYear] = useState(3);
  const [scope, setScope] = useState('room');
  const [method, setMethod] = useState('');

  return (
    <StepShell
      title='Cooling &amp; air conditioning'
      description='Only while you are working from home.'>
      <FieldStack label='Do you use air conditioning or active cooling while WFH?' required>
        <div className='space-y-2'>
          <ChoiceCard
            active={uses === 'yes'}
            icon={Snowflake}
            label='Yes'
            desc='AC unit or heat pump in cool mode'
            onClick={() => setUses('yes')}
          />
          <ChoiceCard
            active={uses === 'no'}
            icon={X}
            label='No'
            desc='Windows, fans, or natural ventilation only'
            onClick={() => setUses('no')}
          />
        </div>
      </FieldStack>

      {uses === 'yes' && (
        <>
          <FieldStack label='On a typical cooling day, how many hours is it on?' required>
            <InputField
              type='number'
              value={hoursPerDay}
              onChange={(e) => setHoursPerDay(Number(e.target.value))}
              min={1}
              max={24}
              className='mb-0'
            />
          </FieldStack>

          <FieldStack label='How many months per year do you use cooling?' required>
            <InputField
              type='number'
              value={monthsPerYear}
              onChange={(e) => setMonthsPerYear(Number(e.target.value))}
              min={1}
              max={12}
              className='mb-0'
            />
          </FieldStack>

          <FieldStack label='What area do you cool while WFH?' required>
            <div className='space-y-2'>
              <ChoiceCard active={scope === 'room'} icon={Square} label='Just 1 room' onClick={() => setScope('room')} />
              <ChoiceCard
                active={scope === 'multi'}
                icon={Layers}
                label='More than 1 room'
                onClick={() => setScope('multi')}
              />
              <ChoiceCard
                active={scope === 'all'}
                icon={Home}
                label='The whole flat or house'
                onClick={() => setScope('all')}
              />
            </div>
          </FieldStack>
        </>
      )}

      {uses === 'no' && (
        <FieldStack
          label='How do you keep your home cool when it’s hot?'
          hint='Optional — helps us improve the survey over time'>
          <InputField
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            placeholder='e.g. fan, open windows, nothing'
            className='mb-0'
          />
        </FieldStack>
      )}

      <div className='rounded-lg bg-muted/50 p-3 flex items-start gap-2 text-xs text-muted-foreground'>
        <Wind size={12} strokeWidth={1.5} className='mt-0.5 flex-shrink-0' />
        Room scope uses a different multiplier for cooling (1/2/4 cooling units) vs heating (0.25/0.5/1.0 area share).
        We apply the right one automatically.
      </div>
    </StepShell>
  );
};

export default Cooling;
